<script>
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { mixin as clickaway } from 'vue-clickaway';
import {
  authComputed,
  authMethods,
  clientComputed,
  clientMethods,
  mediaUploadComputed,
  mediaUploadMethods,
  orgComputed,
  orgMethods,
} from '@/src/state/helpers';
import moment from 'moment';
import resize from '@utils/image-sizer';
import VueSkeletonLoader from 'skeleton-loader-vue';
import _ from 'lodash';
const appConfig = require('@src/app.config');
export default {
  components: { VueSkeletonLoader },
  data() {
    return {
      nextIndex: 0,
      prevIndex: null,
      beforePrev: null,
      photoPreview: null,
      uploadingImg: false,
      key: 0,
      inputKey: 0,
      requestType: 'clients',
      type: 'cover',
      options: [
        {
          routeName: 'Info',
        },
        // {
        //   routeName: 'Subscription',
        // },
        {
          routeName: 'TOS',
        },
        {
          routeName: 'Password',
        },
        {
          routeName: 'Privacy',
        },
        {
          selector: true,
        },
      ],
    };
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [breakpointsMixin, clickaway],
  mounted() {
    if (!this.isMobile) {
      this.nextIndex = this.options.findIndex((route) => route.routeName === this.$route.name);
      this.alignSelectedRect();
    }
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...mediaUploadComputed,
    ...orgComputed,
    selectedItem() {
      return 'profile';
    },
    userAvatar() {
      const photo = this.photoPreview
        ? this.photoPreview
        : this.userProfile &&
          this.userProfile.mediaAssets &&
          this.userProfile.mediaAssets.avatarImage &&
          this.userProfile.mediaAssets.avatarImage.url
        ? resize(this.userProfile.mediaAssets.avatarImage.url, 60, 60)
        : require('@assets/images/placeholder-avatar.png');
      return {
        src: photo,
        error: require('@assets/images/placeholder-avatar.png'),
        loading: require('@assets/images/placeholder-avatar.png'),
      };
    },
    firstName() {
      return (this.userProfile && this.userProfile.firstName) || '';
    },
    lastName() {
      return (this.userProfile && this.userProfile.lastName) || '';
    },
    userName() {
      return `${this.firstName} ${this.lastName}`;
    },
    joinedOn() {
      return this.currentUser && this.currentUser.user && this.currentUser.user.joined_on
        ? moment(this.currentUser.user.joined_on).format('MMMM YYYY')
        : moment().format('MMMMM YYYY');
    },
    cssVars() {
      return {
        '--color': this.primaryColor,
      };
    },
    mailTo() {
      return appConfig.ORG_ID === '618183d65e84466f63c38878'
        ? 'mailto:customtraining@prettymuscles.com'
        : 'mailto:team@smartfitness.com';
    },
  },
  methods: {
    ...clientMethods,
    ...authMethods,
    ...mediaUploadMethods,
    ...orgMethods,
    signOut() {
      this.$bvModal.show('logout-modal');
    },
    alignSelectedRect() {
      const rect = document.getElementsByClassName('selector')[0];
      const item = document.getElementsByClassName('profile-item')[this.nextIndex];

      // add ?. to make sure elements are there when test runs
      const parentNode = rect?.parentNode?.parentNode?.getBoundingClientRect();
      const distanceFromParent = item?.getBoundingClientRect().top - parentNode?.top;
      if (distanceFromParent > 0) {
        rect.style.top = distanceFromParent + 1 + 'px';
      }
    },
    title(route) {
      switch (route) {
        case 'Info':
          return 'My Profile';
        // case 'Subscription':
        //   return 'Manage My Subscription';
        case 'TOS':
          return 'Terms of Use';
        case 'Password':
          return 'Change Password';
        case 'Privacy':
          return 'Privacy Policy';
        default:
          return '';
      }
    },
    newPhotoUrl(type, requestType) {
      return this.hasNewMedia(type, requestType)
        ? this.hasNewMedia(type, requestType).publicUrl
        : this.userProfile.mediaAssets.avatarImage.url;
    },
    imageUploadPayload() {
      const newPhotoUrl = this.newPhotoUrl(this.type, this.requestType);
      const payload = {
        client: {
          profile: {
            ...this.userProfile,
            mediaAssets: {
              avatarImage: {
                url: newPhotoUrl,
              },
            },
          },
        },
      };
      return payload;
    },
    onPickFile() {
      this.isMobile && this.$refs.fileInput.click();
    },
    async uploadImg(e) {
      this.uploadingImg = true;
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        this.photoPreview = evt.target.result;
      };
      await this.getS3UploadUrl({
        file,
        requestType: this.requestType,
        type: this.type,
        orgId: this.orgId,
        trainerId: this.trainerId,
      }).catch((e) => console.error(e));
      await this.uploadPhoto({ model: this.requestType, option: this.type }).catch((e) => console.error(e));
      const payload = await _.cloneDeep(this.imageUploadPayload());
      const response = await this.updateClient({
        clientId: this.clientId,
        trainerId: this.trainerId,
        payload,
      }).catch((e) => console.error(e));
      if (response.success === false) {
        console.error('response', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.client;
        this.setCurrentUser(updatedUser);
      }
      this.inputKey++;
      // clear the image file entery from the state after it has been uploaded
      this.setSignedPostData();
      this.uploadingImg = false;
    },
    async handleClick(i, route) {
      if (!this.isMobile) {
        this.nextIndex = i;
        this.alignSelectedRect();
      }
      if (this.$route.name !== route) {
        await this.$router.push({ name: route });
      }
      this.$emit('hide-router-view');
    },
  },
  watch: {
    nextIndex(n, o) {
      this.prevIndex = o;
    },
  },
};
</script>

<template>
  <div :class="['sidebar-container', { isMobile: isMobile }]" :style="cssVars">
    <div class="sidebar-routes">
      <header v-if="isMobile" class="header-title">Profile</header>

      <div class="row avatar-container">
        <div class="col user-avatar">
          <b-spinner v-show="uploadingImg" type="border" class="spinner m-5" />
          <img v-lazy="userAvatar" @click="onPickFile" />
          <div class="user-container" v-if="userName !== ' '">
            <span class="user-name">{{ userName }}</span>
            <span v-if="isMobile" class="join-date">Member Since {{ joinedOn }}</span>
          </div>
          <div class="user-container" v-else>
            <VueSkeletonLoader :width="300" :height="50" animation="wave" />
            <span v-if="isMobile" class="join-date">Member Since {{ joinedOn }}</span>
          </div>
        </div>
        <input
          :key="inputKey"
          type="file"
          name="uploadfile"
          ref="fileInput"
          :style="{ display: 'none' }"
          accept="image/x-png,image/gif,image/jpeg,image/png"
          @change.prevent="uploadImg($event)"
        />
      </div>
      <div class="row settings-title" v-if="isMobile">
        <span>Settings</span>
      </div>
      <template v-for="(option, i) in options">
        <div v-if="option && option.routeName" :class="['row profile-item']" :key="i">
          <div
            :class="['col option route-click', { selected: i === nextIndex && !isMobile }]"
            @click="handleClick(i, option.routeName)"
          >
            <span class="route-name">{{ title(option.routeName) }}</span>
            <BaseIcon :class="['icon-arrow']" name="chevron-right" v-if="isMobile" />
          </div>
        </div>
        <div
          v-if="option && option.selector"
          class="selector"
          :style="{ display: isMobile ? 'none' : 'flex', '--color': primaryColor }"
          :key="i"
        >
          <BaseIcon :class="['icon-arrow']" name="chevron-right" />
        </div>
      </template>
      <div class="row" v-if="isMobile">
        <div class="col option">
          <a href="mailto:support@plankk.com" target="_blank"><span>Contact Us</span></a>
          <BaseIcon :class="['icon-arrow']" name="chevron-right" />
        </div>
      </div>
      <div class="row">
        <router-link to="/logout" class="col option logout" v-if="isMobile">
          <span>Logout</span>
        </router-link>
        <div class="col option logout" @click="signOut" v-if="!isMobile">
          <span>Logout</span>
        </div>
      </div>
    </div>
    <div class="row contact" v-if="!isMobile">
      <div class="col option">
        <span
          >Having trouble? <strong><a :href="mailTo" target="_blank">Contact Us</a></strong></span
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
.sidebar-container {
  background-color: $color-sidebar-background;
  border-right: 2px rgba(136, 136, 136, 0.4) solid;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-family: $proxima-nova;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  height: 100%;
  justify-content: space-between;
  line-height: 20px;
  padding-left: 2rem;
  padding-top: 3rem;

  &.isMobile {
    background-color: #fff;
    color: #000;
    overflow: auto;
    padding-bottom: 10rem;
    padding-right: 2rem;
    .header-title {
      color: #000;
      font-family: $roboto;
      font-weight: 500;
      padding-bottom: 4rem;
      text-align: center;
      text-transform: capitalize;
    }

    .spinner {
      position: absolute !important;
      right: -10px;
    }

    .sidebar-routes {
      height: 100%;
      .avatar-container {
        .user-avatar {
          align-items: center;
          display: flex;
          flex-direction: row-reverse;
          justify-content: space-between;
          margin-bottom: 2rem;
          mix-blend-mode: normal;
          padding: 0;

          img {
            border-radius: 50%;
            height: 6.3rem;
            object-fit: cover;
            width: 6.3rem;
          }
          .user-container {
            display: flex;
            flex-direction: column;
            font-family: $base-font-family;
            text-transform: capitalize;
            .user-name {
              color: var(--color);
              font-size: 25px;
              font-weight: 800;
              letter-spacing: -0.761905px;
              line-height: 52px;
              margin-left: 0;
              position: relative;
            }
            .join-date {
              color: rgba(0, 0, 0, 0.49);
              font-size: 15px;
              line-height: 18px;
              margin-left: 0;
            }
          }
        }
      }
      .settings-title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
        text-transform: capitalize;
      }
      .option {
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        color: #000;
        cursor: pointer;
        display: flex;
        font-style: normal;
        font-weight: normal;
        justify-content: space-between;
        line-height: 19px;
        mix-blend-mode: normal;
        overflow: hidden;
        padding: 2rem 0;
        position: relative;
        transition: 0.5s all linear;
        white-space: nowrap;
        &.logout {
          color: var(--color);
          font-weight: 600;
          line-height: 17px;
          line-height: 21px;
          padding: 20px 0;
          text-decoration: none;
        }
        svg {
          font-size: 14px;
          line-height: 17px;
          mix-blend-mode: normal;
          opacity: 0.5;
          text-align: right;
        }
        a {
          color: #000;
          font-size: 17px;
          font-weight: normal;
          line-height: 21px;
          text-decoration: none !important;
        }
      }
    }
  }
  .sidebar-routes {
    display: flex;
    flex-direction: column;
    height: 60%;
    justify-content: space-between;
    padding: 0 2rem;

    .avatar-container {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      .user-avatar {
        align-items: center;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 2rem;
        mix-blend-mode: normal;
        padding: 0;

        img {
          border-radius: 50%;
          height: 4.2rem;
          object-fit: cover;
          width: 4.2rem;
        }

        span {
          font-family: $base-font-family;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
          margin-left: 1rem;
          position: relative;
          text-transform: capitalize;
        }
      }
    }

    .route-name {
      z-index: 2;
    }

    .selector {
      align-items: center;
      background-color: var(--color);
      border-radius: 8px;
      display: flex;
      height: 3.3rem;
      justify-content: flex-end;
      left: 4%;
      padding: 3rem 0;
      position: absolute;
      right: 0%;
      top: 15.5%;
      transition: all 0.5s ease;
      width: 83%;

      svg {
        color: white;
        margin-right: 1.5rem;
      }
    }

    .option {
      align-items: center;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      padding-top: 2rem;
      position: relative;
      transition: 0.5s all linear;
      white-space: nowrap;

      &.logout {
        color: #f2f2f2;
        font-size: 17px;
        font-weight: 600;
        line-height: 17px;
        // margin-top: 1rem;
        padding-bottom: unset;
        padding-top: 20px;
        text-decoration: none;
      }
      &.selected {
        color: white;
      }
    }
  }

  .contact {
    margin-bottom: 2rem;
    margin-top: 8rem;
    width: 100%;

    .option {
      align-items: center;
      background: rgba(158, 158, 158, 0.12);
      border-radius: 8px;
      cursor: pointer;
      line-height: 20px;
      margin: 0 2rem 0.3rem 2rem;
      padding: 15px;
      transition: all $duration-animation-base;

      &:hover {
        background: rgba(158, 158, 158, 0.32);
      }
      a {
        color: #fff;
        font-size: 17px;
        font-weight: 600;
        line-height: 21px;
        margin-left: 1rem;
        text-decoration: none !important;
      }
    }
  }
}
</style>
